export const reportReasonsDict: Record<string, string> = {
  foreign_photos: 'Чужие фотографии',
  insult: 'Оскорбление',
  obscene_photos: 'Непристойные фотографии',
  spam: 'Спам',
  other: 'Другое',
};
